<template>
  <div class="app-cart">
    <h2 class="h3" v-if="showHeadline"><slot name="lblHeadline">Lorem, ipsum.</slot></h2>
    <table class="cart--row price-table">
      <caption class="sr-only"><slot name="captionPriceTable">Preise</slot></caption>
      <tbody>
      <tr class="price" :class="{'promo': hasPricePromotion, 'mergedRow': hasLimitedPricePromotion}" aria-live="polite" aria-atomic="true">
        <td><strong><slot name="lblPrice">Lorem, ipsum.</slot> <span class="small"><slot name="lblMonthly">monatlich</slot></span></strong></td>
        <td>
            <span class="sr-only" :key="'price-' + promoBenefits.promoPrice.promoAmount">
              {{showPriceStarts ? 'ab' : ''}} {{priceWithoutEuro(promoBenefits.promoPrice.promoAmount)}}€
            </span>
          <span aria-hidden="true" v-if="hasPricePromotion" class="price--strikethrough"><strong>{{price(fakeNormalPriceForBirthdayPromo)}}</strong></span>
          <span aria-hidden="true" v-if="showPriceStarts" class="price--label"><strong>&nbsp;ab&nbsp;</strong></span>
          <span aria-hidden="true" class="price--amount">{{priceWithoutEuro(promoBenefits.promoPrice.promoAmount)}}</span>
          <span aria-hidden="true"> <strong class="price--label">&nbsp;&euro;</strong></span>
        </td>
      </tr>

      <template v-if="hasLimitedPricePromotion">
        <tr class="limited-price" :class="{'last-limited-price': index === promoBenefits.additionalPriceStairways.length - 1}" v-for="(stairway, index) in promoBenefits.additionalPriceStairways" :key="stairway.duration">
          <td>
            <strong><dyn-slot :slotData="stairway"><slot name="dynLimitedPrice">Ab dem XX Monat</slot></dyn-slot></strong>
          </td>
          <td>
            <span class="sr-only">{{showPriceStarts ? 'ab' : ''}} {{price(stairway.promoAmount)}}</span>
            <span aria-hidden="true"><strong v-if="showPriceStarts" class="limited-price--starts">ab&nbsp;</strong></span>
            <span aria-hidden="true"><strong class="limited-price--amount" >{{price(stairway.promoAmount)}}</strong></span>
          </td>
        </tr>
      </template>

      <tr>
        <td>
          <strong><slot name="lblConnectionFee">Lorem, ipsum.</slot> <span class="small"><slot name="lblOnetime">einmalig</slot></span></strong>
        </td>
        <td>
          <strong>0 &euro;</strong>
        </td>
      </tr>

      <tr v-if="process !== 'activation'">
        <td>
          <strong><slot name="lblShippingCosts">Lorem, ipsum.</slot> <span class="small"><slot name="lblOnetime">einmalig</slot></span></strong>
        </td>
        <td>
          <strong>0 &euro;</strong>
        </td>
      </tr>
      </tbody>
    </table>

    <div class="cart--row features">
      <ul class="checklist">
        <li class="promo" v-if="hasSpecialVoucherPromotion"><slot :name="getSpecialVoucherPromotionSlot"></slot></li>
        <li class="volume promo" :class="{'volume--limited': promoBenefits.promoCodeVolume.limitedVolume.promoAmount > 0}" v-if="hasPromoCodeVolumePromotion">
          <span>
            <strong>+{{(promoBenefits.promoCodeVolume.volume.promoAmount + promoBenefits.promoCodeVolume.limitedVolume.promoAmount)}} {{promoBenefits.volume.unit}}</strong>
            <span aria-hidden="true">&nbsp;mtl.</span>
            <span class="sr-only">monatlich</span>
          </span>
          <dyn-slot :slotData="promoBenefits.promoCodeVolume.limitedVolume" :key="slotNameForPromoCodeVolume" class="slot-dyn-limited-volume"><slot :name="slotNameForPromoCodeVolume"></slot></dyn-slot>
        </li>
        <li class="promo" v-if="hasBucketVolumePromotion">
          <dyn-slot :slotData="promoBenefits.bucketVolume" :key="slotNameForBucketVolume"><slot :name="slotNameForBucketVolume"></slot></dyn-slot>
        </li>
        <li class="volume" :class="{'promo': hasVolumePromotion || hasLimitedVolumePromotion }">
          <span><strong>{{(promoBenefits.volume.promoAmount + promoBenefits.limitedVolume.promoAmount)}} {{promoBenefits.volume.unit}}</strong></span>
          <span class="sr-only">monatlich</span>
          <span aria-hidden="true">&nbsp;mtl.</span>
          <dyn-slot :slotData="promoBenefits.limitedVolume" :key="slotNameForVolume"><slot :name="slotNameForVolume"></slot></dyn-slot>
        </li>
        <li v-if="getDefaultStartingBonus || hasPromoStartingBonus" class="price" :class="{'promo': hasPromoStartingBonus}"> <strong>{{promoBenefits.startingBonus / 100}} €</strong>&nbsp;<slot name="lblStartingBonus"></slot></li>
        <li class="promo" v-for="textRow in promoTextRows" :key="textRow" v-html="textRow"></li>
        <dyn-slot  :slotData="mBitSForSelection" key="listTariffHighlights"><slot name="listTariffHighlights"><li>Lorem, ipsum dolor.</li></slot></dyn-slot>
      </ul>
      <div aria-hidden="true" class="trustedShops"><slot name="imageTrustedShops"></slot></div>
    </div>
    <div class="cart--row infos">
      <strong><slot name="lblTax">Lorem ipsum dolor sit.</slot></strong>
      <div><slot name="txtInfoLink">Lorem, ipsum.</slot></div>
    </div>
  </div>
</template>

<script>

import voucherConfig from '@/mixins/voucherConfig'
import price from '@/mixins/formatters/price'
import formatDecimal from '@/mixins/formatters/formatDecimal'
import useFeature from '@/mixins/useFeature'

export default {
  name: 'Cart',
  mixins: [
    voucherConfig,
    price,
    formatDecimal,
    useFeature('birthdayPromo')
  ],
  props: {
    promoBenefits: {
      type: Object,
      default: null
    },
    process: {
      type: String,
      default: 'ordering'
    },
    showPriceStarts: {
      type: Boolean,
      default: true
    },
    voucherPromotions: {
      type: Array,
      default: () => { return [] }
    },
    showHeadline: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    mBitSForSelection () {
      const defaultBandwidth = '100'
      const targetTariffBandwidth = this.targetTariff && this.targetTariff.bandwidth
        ? this.targetTariff.bandwidth.down
        : defaultBandwidth

      const targetTariffOptionBandwidth = this.targetTariffoptions?.length > 0 && this.targetTariffoptions[0].bandwidth
        ? this.targetTariffoptions[0].bandwidth.down
        : targetTariffBandwidth

      return { mbits: targetTariffOptionBandwidth }
    },
    targetTariffoptions () {
      return this.$store.getters['checkoutv2/' + this.process + '/_cart/targetTariffoptions']
    },
    targetTariff () {
      return this.$store.getters['checkoutv2/' + this.process + '/_cart/targetTariff']
    },
    hasPricePromotion: function () {
      return this.fakeNormalPriceForBirthdayPromo !== this.promoBenefits.promoPrice.promoAmount // this.promoBenefits.price.amount
    },
    selectedAboOptionIdForFakeBirthdayPromo: function () {
      return this.$store.getters['checkoutv2/' + this.process + '/_cart/selectedTariffOptionIds']?.length > 0 ? this.$store.getters['checkoutv2/' + this.process + '/_cart/selectedTariffOptionIds'][0] : []
    },
    fakeNormalPriceForBirthdayPromo () {
      if (this.birthdayPromo && this.selectedAboOptionIdForFakeBirthdayPromo === '3036138') {
        return this.promoBenefits.price.amount + 500
      }
      return this.promoBenefits.price.amount
    },
    hasLimitedPricePromotion: function () {
      return this.promoBenefits.promoPrice.duration > 0
    },
    hasPromoCodeVolumePromotion: function () {
      return this.promoBenefits.promoCodeVolume.volume.promoAmount > 0 || this.promoBenefits.promoCodeVolume.limitedVolume.promoAmount > 0
    },
    slotNameForPromoCodeVolume () {
      if (this.promoBenefits.promoCodeVolume.limitedVolume.promoAmount > 0) {
        return 'dynPromoCodeLimitedVolume' + (this.promoBenefits.limitedVolume.duration === 1 ? 'FirstMonth' : 'Default')
      } else {
        return 'lblPromoCodeVolume'
      }
    },
    hasVolumePromotion: function () {
      return this.promoBenefits.volume.amount !== this.promoBenefits.volume.promoAmount
    },
    hasLimitedVolumePromotion: function () {
      return this.promoBenefits.limitedVolume.promoAmount > 0
    },
    slotNameForVolume () {
      if (this.hasLimitedVolumePromotion) {
        return 'dynLimitedVolume' + (this.promoBenefits.limitedVolume.duration === 1 ? 'FirstMonth' : 'Default')
      } else {
        return 'lblVolume'
      }
    },
    hasBucketVolumePromotion: function () {
      return this.promoBenefits.bucketVolume.promoAmount > 0
    },
    slotNameForBucketVolume () {
      return 'dynBucketVolume' + (this.promoBenefits.limitedVolume.duration === 1 ? 'FirstMonth' : 'Default')
    },
    promoTextRows () {
      if (this.process === 'ordering') {
        return this.$store.getters['checkoutv2/' + this.process + '/_cart/promoTextRows']
      } else {
        return []
      }
    },
    hasSpecialVoucherPromotion: function () {
      return this.voucherPromotions && this.voucherPromotions.length !== 0 && this.getSlotText(this.getSpecialVoucherPromotionSlot) !== ''
    },
    getSpecialVoucherPromotionSlot: function () {
      if (this.voucherPromotions.length !== 0 && this.voucherPromotions[0].promotionId) {
        return 'txtSpecialShoppingCartListItem' + this.getSlotIdForVoucherPromo(this.voucherPromotions[0].promotionId)
      }
      return ''
    },
    getDefaultStartingBonus: function () {
      const defaultStartingBonus = this.getSlotText('defaultStartingBonus')
      if (defaultStartingBonus &&
        defaultStartingBonus !== '' &&
        defaultStartingBonus !== null &&
        defaultStartingBonus > 0 &&
        !isNaN(defaultStartingBonus)) {
        return defaultStartingBonus
      } return 0
    },
    hasPromoStartingBonus: function () {
      return this.promoBenefits.startingBonus > this.getDefaultStartingBonus
    }
  }
}
</script>
